import axios from 'axios';
import { API_BASE_URL } from '../../../constants';
import { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';

export const fetchResetInstagramFeedData = async () => {
  return axios
    .get(`${API_BASE_URL}/instagram-feeds?q=reset-cache`)
    .then((res) => {
      const responseData = res.data.data;
      return responseData;
    })
    .catch((err) => {
      console.log(err);
      return [];
    });
};

export const useFetchResetInstagramFeedData = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    const exec = async () => {
      try {
        setIsLoading(true);
        const response = await fetchResetInstagramFeedData();
        setData(response);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
        setIsLoading(false);
      }
    };

    exec();

    return () => {
      setIsLoading(false);
      setData([]);
    };
  }, []);

  return {
    isLoading,
    data,
  };
};
